import { PermissionGuard } from './PermissionGuard';

import type { ReactNode } from 'react';

import { useEmployeePortalAccess } from '@/hooks/api/useEmployeePortalAccess';

/**
 * Guards the My portal route by the portal access rule (#17107): the company administrator, the
 * role permission every role holds by default, or a performance scope. Renders nothing while the
 * answer loads and sends a refused reader to the default route, as `WithPermission` does.
 */
export const WithEmployeePortalAccess = ({ children }: { children: ReactNode }) => (
    <PermissionGuard hasPermission={useEmployeePortalAccess()}>{children}</PermissionGuard>
);
